/* Desconto por volume — UI estilo Fast Bundle.
   Sincroniza faixa <-> quantidade <-> preço. O desconto real é aplicado pela
   Shopify Discount Function no checkout (2un=4%, 3+un=10%); aqui é só UX/display. */
(function () {
  function moneyBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function init(box) {
    var section = box.dataset.section;
    var qtyInput = document.getElementById('Quantity-' + section);
    if (!qtyInput) {
      // PDP sem o bloco "quantity_selector" do tema (ex.: setup do Fast Bundle):
      // criamos um <input name="quantity"> oculto vinculado ao form do produto via atributo `form`,
      // exatamente como o Dawn associa o seletor nativo. O FormData(form) inclui inputs form-associados.
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.setAttribute('form', 'product-form-' + section);
      qtyInput.value = '1';
      box.appendChild(qtyInput);
    }
    var base = +box.dataset.base, t2 = +box.dataset.t2, t3 = +box.dataset.t3;
    // preço principal (topo do buy box) acompanha a faixa selecionada
    var topWrap = document.getElementById('price-' + section);
    var topNew = topWrap && topWrap.querySelector('.product-price-new');
    var topOld = topWrap && topWrap.querySelector('.product-price-old');
    var topNewInit = topNew ? topNew.textContent : null;
    var topOldInit = topOld ? topOld.textContent : null;
    var opts = [].slice.call(box.querySelectorAll('.vt-opt'));

    function pctForTier(tq) { return tq >= 3 ? t3 : (tq === 2 ? t2 : 0); }
    function activeTierFor(q) { return q >= 3 ? 3 : (q === 2 ? 2 : 1); }

    function render(q) {
      q = Math.max(1, q | 0);
      var active = activeTierFor(q);
      opts.forEach(function (opt) {
        var tq = +opt.dataset.qty;
        var sel = (tq === active);
        opt.classList.toggle('is-selected', sel);
        var radio = opt.querySelector('.vt-radio-input');
        if (radio) radio.checked = sel;
        var dispQty = sel ? q : tq;          // a faixa ativa reflete a quantidade real
        var pct = pctForTier(tq);
        var priceEl = opt.querySelector('[data-price]');
        var origEl = opt.querySelector('[data-orig]');
        var numEl = opt.querySelector('[data-num]');
        if (priceEl) priceEl.textContent = moneyBRL(Math.round(base * dispQty * (100 - pct) / 100));
        if (origEl) origEl.textContent = moneyBRL(base * dispQty);
        if (numEl) numEl.textContent = dispQty;
        if (sel && topNew) {
          if (q > 1) {
            topNew.textContent = moneyBRL(Math.round(base * q * (100 - pct) / 100));
            if (!topOld) {
              topOld = document.createElement('span');
              topOld.className = 'product-price-old';
              topNew.parentNode.insertBefore(topOld, topNew);
            }
            topOld.textContent = moneyBRL(base * q);
            topOld.style.display = '';
          } else {
            topNew.textContent = topNewInit;
            if (topOld) {
              if (topOldInit) { topOld.textContent = topOldInit; topOld.style.display = ''; }
              else { topOld.style.display = 'none'; }
            }
          }
        }
        var fromEl = opt.querySelector('[data-from]');
        if (fromEl) fromEl.style.display = (dispQty === 3) ? '' : 'none'; // "a partir de" só vale no preço-base da faixa
      });
    }

    function setQty(q) {
      q = Math.max(1, q | 0);
      if (qtyInput) {
        qtyInput.value = q;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      render(q);
    }

    function currentQty() {
      return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    }

    // selecionar uma faixa (clique no card/rádio) -> ajusta a quantidade base da faixa
    box.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('vt-radio-input')) {
        setQty(+e.target.value);
      }
    });

    // stepper +/-  (não deixa o clique selecionar/propagar)
    box.addEventListener('click', function (e) {
      var step = e.target.closest && e.target.closest('.vt-step');
      if (!step) return;
      e.preventDefault();
      e.stopPropagation();
      setQty(currentQty() + (+step.dataset.dir));
    });

    // quantidade alterada por fora (stepper nativo do produto) -> reflete aqui
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { render(currentQty()); });
    }

    // troca de variante (Dawn pub/sub) -> recalcula com o novo preço
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var v = ev && ev.data && ev.data.variant;
          if (v && typeof v.price === 'number') {
            base = v.price; box.dataset.base = v.price; render(currentQty());
          }
        });
      }
    } catch (e) { /* sem pub/sub: mantém o preço do default */ }

    render(currentQty());
  }

  document.querySelectorAll('.vt').forEach(init);
})();
